import { css } from "@codemirror/lang-css";
import { html } from "@codemirror/lang-html";
import { javascript } from "@codemirror/lang-javascript";
import { xml } from "@codemirror/lang-xml";
import { json } from '@codemirror/lang-json'; 

// Вибір розширення синтаксису відносно роозширення файлу
export const extFile2Extensions = (extFile) => {    
    switch (extFile?.toLowerCase()||''){
        case '.css':
            return css();

        case '.js':
            return javascript();

        case '.json':
            return json();

        case '.xml':
            return xml();

        case '.html':
            return html();

        default:
            return [];
    }

    
}

// Вибір розширення для синтаксису
export const getExtensions = (syntaxType) => {
    switch (syntaxType) {

        case 'html':
            return html();
        
        case 'css':
            return css();

        case 'javascript':
            return javascript();

        case 'json':
            return json();

        case 'xml':
            return xml();

        default:
            return [];
    }
};